module.exports = __webpack_public_path__ + "static/media/bg-mobile1.92b93b87.svg";